import { computed, ref, onMounted } from 'vue'
import StafetHeader from '../StafetHeader/StafetHeader.vue'
import FormStepSubmitting from '../FormStepSubmitting/FormStepSubmitting.vue'
import StafetDeltagSomFighterStepOne from '../StafetDeltagSomFighterStepOne/StafetDeltagSomFighterStepOne.vue'
import StafetDeltagSomFighterStepTwo from '../StafetDeltagSomFighterStepTwo/StafetDeltagSomFighterStepTwo.vue'
import StafetDeltagSomFighterStepThree from '../StafetDeltagSomFighterStepThree/StafetDeltagSomFighterStepThree.vue'
import { scrollToFirstError } from '../../foundation/js/inputValidators/scrollToFirstError'
import { useStore } from 'vuex'
import mapStafetHeaderSteps from 'foundation/js/stafet/mapStafetHeaderSteps'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import getCommonComputedFields from 'foundation/js/stafet/getCommonComputedFields'
import stepsConfig from './config/stepsConfig'
import fieldValidator from 'foundation/js/stafet/fieldValidator'
import updateItemFromStorage from 'foundation/js/sessionStorageWrapper/updateItemFromStorage'
import updateBasket from './methods/updateBasket'

export default {
    name: 'StafetDeltagSomFighterFlow',
    components: {
        StafetHeader,
        FormStepSubmitting,
        StafetDeltagSomFighterStepOne,
        StafetDeltagSomFighterStepTwo,
        StafetDeltagSomFighterStepThree
    },
    props: {
        stafetId: {
            type: String,
            required: true
        },
        tshirtSizes: {
            type: Array,
            required: false,
            default: []
        },
        donationAmount: {
            type: Array,
            required: false,
            default: []
        },
        loggedIn: {
            type: Boolean,
            required: false,
            default: false
        },
        redirectToEditProfile: {
            type: String,
            required: false,
            default: ''
        },
        editProfileLinkText: {
            type: String,
            required: false,
            default: ''
        },
        holdList: {
            type: Array,
            required: false,
            default: []
        },
        userData: {
            type: Object,
            required: false,
            default: {}
        },
        adultPrice: {
            type: Number,
            required: true
        },
        childPrice: {
            type: Number,
            required: true
        }
    },
    setup(props) {
        const store = useStore()
        const displayInputError = ref(false)

        const labels = computed(() => {
            return store.state.labels.collections['SFLJoinAsFighterLabels']
        })

        const isSubmitting = computed(() => {
            return store.state.stafet.isSubmitting
        })

        const headerSteps = computed(() => {
            return mapStafetHeaderSteps(
                steps.value,
                currentStep.value,
                labels.value
            )
        })

        const { userInputs, steps, currentStep, currentStepName } =
            getCommonComputedFields(store.state.stafet)

        onMounted(() => {
            store.dispatch('stafet/stafetId', { stafetId: props.stafetId })
            store.dispatch('stafet/steps', {
                steps: stepsConfig
            })
        })

        const handleStepCompleted = () => {
            steps.value.find(
                (item) => item.step === currentStep.value
            ).completed = true

            store.dispatch('stafet/steps', {
                steps: steps.value
            })

            const unCompletedSteps = steps.value.filter(
                (item) => !item.completed
            )

            if (unCompletedSteps.length > 0) {
                store.dispatch('stafet/currentStep', {
                    step: unCompletedSteps[0].step
                })
            }
        }

        const nextStepCallback = (fields) => {
            fields.forEach((field) => {
                if (field.dependentField) {
                    const dependentField = fields.find(
                        (item) => item.name === field.dependentField
                    )

                    if (dependentField) {
                        field.dependentFieldValue = dependentField.value
                    }
                }
                fieldValidator(field)
            })

            const isStepValid = fields.every((field) => field.isValid)
            if (isStepValid) {
                displayInputError.value = false
                handleStepCompleted()
                store.dispatch('stafet/userInputs', { inputs: fields })
                updateItemFromStorage(
                    sessionStorageIdentifierEnum.STAFET_JOIN_AS_FIGHTER,
                    fields
                )
                updateBasket(
                    userInputs.value,
                    labels.value,
                    store,
                    props.adultPrice,
                    props.childPrice
                )

                scrollTo(0, 0)  
            } else {
                displayInputError.value = true
                scrollToFirstError()
            }
        }

        const updateBasketCallback = () => {
            updateBasket(userInputs.value, labels.value, store, props.adultPrice, props.childPrice)
        }

        const previousStepCallback = () => {
            if (currentStep.value > 1) {
                store.dispatch('stafet/currentStep', {
                    step: currentStep.value - 1
                })

                steps.value.find(
                    (item) => item.step === currentStep.value
                ).completed = false

                store.dispatch('stafet/steps', {
                    steps: steps.value
                })

                scrollTo(0, 0)  
            }
        }

        const submitCallback = async () => {
            // it expects a object with ok: true or false
            await store.dispatch('stafet/joinAsAFighterSubmit')
            return 'submitted'
        }

        return {
            labels,
            headerSteps,
            currentStepName,
            displayInputError,
            isSubmitting,
            nextStepCallback,
            previousStepCallback,
            submitCallback,
            updateBasketCallback
        }
    }
}
